/* eslint-disable import/no-cycle */
import {decorate, observable, runInAction} from 'mobx';
import {User} from '../models/user';
import {EntityStore} from './entityStore';
import {Api} from '../middleware/api';
import {updatePasswordEndpoint, UsersApi} from '../middleware/endpoints/users';

export const UserStoreActions = {
  changePassword: 'changePassword',
};

export class UserStore extends EntityStore {
  users = [];

  constructor(rootStore) {
    super(rootStore, 'users', Api.users, User);
  }

  updatePassword(entity) {
    return this.update(
      entity,
      {
        api: UsersApi,
        apiEndpoint: updatePasswordEndpoint,
      }
    );
  }

  changePassword(data) {
    const options = {
      action: UserStoreActions.changePassword,
    };

    this.addPendingAction(options.action);

    const {oldPassword, newPassword} = data;
    return this.api.changePassword(
      {oldPassword, newPassword}
    ).then((res) => {
      runInAction(() => this.removePendingAction(options.action));
      return res;
    }).catch((err) => {
      this.handleApiError(err, options.action);
      return null;
    });
  }
}

decorate(UserStore, {
  users: observable,
});
